import React from 'react';
import { credits } from './nxlUtils';

function LeaderboardPanel({ leaderboard }) {
  return (
    <section className="nxl-panel">
      <p className="nxl-kicker">TRADER LEADERBOARD</p>
      <h2>Top balances</h2>

      <div className="nxl-ranking-list">
        {leaderboard.map((row) => (
          <div className="nxl-ranking-row" key={`${row.rank}-${row.display_name}`}>
            <span>#{row.rank}</span>
            <strong>{row.display_name}</strong>
            <em>{credits(row.balance)}</em>
          </div>
        ))}
      </div>
    </section>
  );
}

export default LeaderboardPanel;